export interface ISavePreferencesEventArgs {}

export class PreferencesPanelEvents {
  public static savePreferences = 'savePreferences';
  public static exitPreferencesWithoutSave = 'exitPreferencesWithoutSave';
}



// WEBPACK FOOTER //
// ./src/events/PreferencesPanelEvents.ts